export const KILDE_LABELS: Record<string, string> = {
  'brreg-underenhet': 'Brreg underenhet',
  'google-places': 'Google Places',
  facebook: 'Facebook',
};

export const buildKildeLink = (kilde: string, eksternId: string): string | undefined => {
  if (kilde === 'brreg-underenhet')
    return `https://virksomhet.brreg.no/nb/oppslag/underenheter/${eksternId}`;
  if (kilde === 'google-places')
    return `https://www.google.com/maps/place/?q=place_id:${eksternId}`;
  if (kilde === 'facebook') return eksternId;
  return undefined;
};
